import styled from 'styled-components';
import {Avatar} from '@sproutsocial/seeds-react-avatar';
import {Box} from '@sproutsocial/seeds-react-box';
import {Link} from '@sproutsocial/seeds-react-link';
import {Skeleton} from '@sproutsocial/seeds-react-skeleton';
import {Text} from '@sproutsocial/seeds-react-text';
import {type TypePageData} from '../services';

const StyledLink = styled(Link)`
	width: 100%;
	&:hover {
		text-decoration: none;
	}
`;

const DisplayNameText = styled(Text)`
	text-align: center;
	overflow-wrap: break-word;
`;

type TypeLogoProps = {
	page: TypePageData | null | undefined;
};

export default function Logo({page}: TypeLogoProps) {
	if (!page) {
		return (
			<Box display='flex' justifyContent='center'>
				<Box display='flex' flexDirection='column' alignItems='center'>
					<Skeleton width='60px' height='60px' borderRadius='pill' mb={350} />
					<Skeleton width='140px' height='24px' />
				</Box>
			</Box>
		);
	}

	const {display_name, profile_name, profile_image_url} = page;

	return (
		<Box as='header' display='flex' justifyContent='center'>
			<StyledLink
				external
				href={`https://www.instagram.com/${profile_name}`}
				underline={false}
				rel='noreferrer'
				display='flex'
				flexDirection='column'
				alignItems='center'
			>
				<Avatar name={profile_name} src={`/${profile_image_url}`} size='60px' mb={350} />
				<Box width={1} display='flex' justifyContent='center' px={450}>
					<DisplayNameText
						forwardedAs='h1'
						color='text.headline'
						fontSize={400}
						fontWeight='semibold'
						width='100%'
						maxWidth='600px'
					>
						{display_name || profile_name}
					</DisplayNameText>
				</Box>
			</StyledLink>
		</Box>
	);
}
